import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * @typedef {Object} TemplateRenderer
 * @property {string} html
 * @property {function(unknown): boolean} match
 * @property {function(unknown): number} indexOf
 */

/**
 * Mengubah text yang match dengan pattern menggunakan custom element dengan
 * tujuan untuk ditransformasi saat proses rendering.
 * @param {string} string text awal yang ingin diubah.
 * @param {RegExp} pattern pattern dari text yang ingin diubah.
 * @returns {TemplateRenderer}
 */
export default function useTemplateRenderer(string, pattern) {
  // Custom attribute yang akan digunakan untuk menentukan komponen.
  const group = useMemo(() => uuidv4(), []);

  // String baru yang telah menghilangkan
  const html = useMemo(() => {
    let index = 0;
    // Replace pattern dengan span dan ditambahkan attribute `template-group-id`
    // dan attribute index.
    return string.replace(
      pattern,
      // eslint-disable-next-line no-plusplus
      () => `<span template-group-id="${group}" index="${index++}"></span>`
    );
  }, [group, pattern, string]);

  // Mengecek apakah node ini merupakah elemen yang sudah diubah.
  const match = (node) =>
    node.name === 'span' && node.attribs?.['template-group-id'] === group;

  // Mendapatkan index dari elemen yang diubah.
  const indexOf = (node) => {
    try {
      return parseInt(node.attribs.index, 10);
    } catch {
      return -1;
    }
  };

  return { html, match, indexOf };
}
